import React from 'react';

const InputField = ({ label, className, input, placeholder, meta, after, groupComponent }) => (
    <div className={`form-group ${(groupComponent) ? 'input-group' : '' }`}>
        <label className="form-control-label">{label}</label>
        <input className={className} placeholder={placeholder} {...input} />
        {meta.error && meta.touched && <span className="pl-1 small text-danger">{meta.error}</span>}
        {after}
    </div>
);

export default InputField;


// WEBPACK FOOTER //
// ./src/components/InputField.js